import React from 'react';

import { PlanTable } from 'modules/components/layer25';
import { ActivitySectionLayout } from 'modules/components/layer32';


export type PlanSetDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlanSetDetailSectionProps) => {

  return (
    <ActivitySectionLayout.FC
      title='PlanSetDetailSection'
    >
      <PlanTable.FC />
    </ActivitySectionLayout.FC>

  );
};



